import React, { useState } from 'react';
import FullModal from './FullModal';
import { Building2, UserPlus, ChevronDown } from 'lucide-react';
import { useAuth } from '../../hooks/useAuth';
import { useOrganization } from '../../hooks/useOrganization';
import { InputTextField } from '../Input/InputTextField';
import { InputSelect } from '../Input/InputSelect';
import { Box, Button } from '@mui/material';
import { validateEmail } from '../../utils/validations';
import { LoaderSpinner } from './LoaderSpinner';
import { toast } from 'react-hot-toast';
import { successToastConfig } from '../../utils/data';
import { useNavigate } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import OutlinedInput from '@mui/material/OutlinedInput';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import Chip from '@mui/material/Chip';


const TeamInvite = ({invite}) => {
  const { user } = useAuth();
  const { sendInvite, fetchOrganizationInvites, accountSelected, getAccountsList } = useOrganization();
  const [email, setEmail] = useState('');
  const [role, setRole] = useState( invite === 'user' ? 'user' : 'admin' );
  const [loading, setLoading] = useState(false);
  const [accountAdded, setAccountAdded] = React.useState([]);
  const navigate = useNavigate();
  const theme = useTheme();
  const ITEM_HEIGHT = 48;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 250,
      },
    },
  };

const [, ...updatedAccountList] = getAccountsList;
  const handleUpdate = (field) => (value) => {
    setEmail(value);
  };

  const handleUserRole = (value) => {
    setRole(value);
  }

  const handleInviteClick = async () => {
    setLoading(true);
        const accountIdAdded = updatedAccountList
        .filter(obj => accountAdded.includes(obj.name))
        .map(obj => obj._id);

    const res = await sendInvite(email, role, accountIdAdded, invite);
    
    setTimeout(() => {
        setLoading(false);
        if(invite === 'user'){
            navigate('/team');
        }else{
            navigate('/organizations');
        }
        
        accountSelected !== null && fetchOrganizationInvites();
        
        toast('Invite sent successfully', successToastConfig);
    }, 2000);
  };

   const handleChange = (event) => {
    const {
      target: { value },
    } = event;
    setAccountAdded(
      // On autofill we get a stringified value.
      typeof value === 'string' ? value.split(',') : value,
    );
  };
  const getStyles = (name, accountAdded, theme) => {
  return {
    fontWeight: accountAdded.includes(name)
      ? theme.typography.fontWeightMedium
      : theme.typography.fontWeightRegular,
  };
}

  return (
    <FullModal>
        <div className="flex-row align-center">
            
            { invite === 'user' ? "" : <Building2 size={24} style={{ marginRight: 10, color: 'var(--brand-blue)' }} /> }
            <UserPlus size={24} style={{ color: 'var(--brand-blue)' }} />
        </div>

        { invite === "user" ? (
            <p style={{opacity: 1}}>
                Invite a user to join <Building2 size={15} style={{ marginLeft: 5, marginBottom: -2,color: 'var(--brand-blue)' }} /> <span style={{fontWeight: 'bold'}}>{user.organization.name}</span>
            </p>
        ):(
            <p style={{opacity: 1}}>
                Invite a user to create an organization.
            </p>
        )}

        <InputTextField
            onChange={handleUpdate("email")}
            placeholder='Email Address'
            value={email}
            validate={validateEmail}
            validateLive={true}
        />
        <FormControl
          fullWidth
          sx={{
            my: '10px',
            backgroundColor: '#ffffff',
            borderRadius: '8px',
            '& .MuiOutlinedInput-root': {
              background: '#ffffff',
              borderRadius: '8px',
              transition: 'all 0.2s ease',
              color: 'var(--text-primary)',
              minHeight: '48px',
              cursor: 'pointer',
              '& .MuiOutlinedInput-notchedOutline': {
                borderColor: 'var(--border-input)',
                borderWidth: '1px',
              },
              '&:hover': {
                background: '#ffffff',
              },
              '&:hover .MuiOutlinedInput-notchedOutline': {
                borderColor: 'var(--brand-blue)',
              },
              '&.Mui-focused': {
                background: '#ffffff',
                boxShadow: '0 0 0 2px rgba(135, 206, 250, 0.16)',
              },
              '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                borderColor: 'var(--brand-blue)',
                borderWidth: '1px',
              },
            },
            '& .MuiSelect-select': {
              backgroundColor: '#ffffff !important',
              display: 'flex',
              alignItems: 'center',
              minHeight: '48px !important',
              padding: '12px 18px',
              color: 'var(--text-primary)',
              cursor: 'pointer',
            },
            '& .MuiInputBase-input': {
              backgroundColor: '#ffffff !important',
            },
            '& .MuiSelect-icon': {
              color: 'var(--text-primary)',
              opacity: 0.8,
            },
            '&:hover .MuiSelect-icon': {
              color: 'var(--brand-blue)',
              opacity: 1,
            },
          }}
        >
        <Select
          id="demo-multiple-chip"
          multiple
          displayEmpty
          value={accountAdded}
          onChange={handleChange}
          input={<OutlinedInput id="select-multiple-chip" notched={false} />}
          renderValue={(selected) => (
            selected.length === 0 ? (
              <span style={{ color: 'var(--text-muted)', fontWeight: 400 }}>Select Account</span>
            ) : (
              <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.75 }}>
                {selected.map((value) => (
                  <Chip
                    key={value}
                    label={value}
                    size="small"
                    sx={{
                      background: 'rgba(135, 206, 250, 0.12)',
                      color: 'var(--text-primary)',
                      border: '1px solid rgba(135, 206, 250, 0.35)',
                    }}
                  />
                ))}
              </Box>
            )
          )}
          MenuProps={MenuProps}
        >
          {updatedAccountList.map((account) => (
            <MenuItem
              key={account._id}
              value={account.name}
              sx={{'&.Mui-selected': { background: 'var(--bg-selected)', color: '#73787c !important' }}}
              style={getStyles(account.name, accountAdded, theme)}
            >
              {account.name}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
        {/* <div className="input-select">
            <InputSelect
                title="User Role"
                onChange={handleUserRole}
                value={role}
                options={['User',invite === 'organization' ? 'Owner + Admin' : 'Admin']}
                optionsValues={['user','admin']}
                disabled={invite === 'organization'}
            >
                <ChevronDown className="select-arrow" size={16} />
            </InputSelect>
        </div> */}
        <div style={{width: '100%',marginTop: 16}} className="flex-row align-center">
            <Button
                variant="contained" 
                color="primary"
                onClick={handleInviteClick}
                className={validateEmail(email) ? 'disabled' : ''}
            >
                Invite
            </Button>
            { loading && <LoaderSpinner style={{marginLeft: 20}} absolute={false} /> }
        </div>
        
    </FullModal>
  );
};

export default TeamInvite;
